var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.997 42.6729C56.5905 41.4457 60 36.9089 60 31.5C60 25.1487 55.299 20 49.5 20C45.2886 20 41.6563 22.7155 39.9831 26.635C38.5576 26.2213 37.0539 26 35.5 26C26.3873 26 19 33.6112 19 43C19 52.3888 26.3873 60 35.5 60C44.6127 60 52 52.3888 52 43C52 42.8907 51.999 42.7816 51.997 42.6729ZM49.5 43C50.3604 43 51.1967 42.8867 51.997 42.6729C51.857 35.0288 46.8199 28.6191 39.9831 26.635C39.3523 28.1125 39 29.7612 39 31.5C39 37.8513 43.701 43 49.5 43Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.e508c0cff506ca14843c77f395c8c324.svg";
export { ForwardRef as ReactComponent };